import { createReducer } from 'redux-starter-kit';
import { putChecklistCategoryConfig, putChecklistConfig, putChecklistsConfig } from './checklistsConfigActions';

/**
 * A selector for the checklists loaded in the domain state.
 * This is a dict object: { checkListCde: checklist}
 * @param {state} state The redux state of the application.
 *
 * @example const checklist = selectChecklistMap(state)[yourCode]
 */
export const selectChecklistsConfigMap = state => state.via.domain.checklistsConfig;

// A dict object with a property key of: checkListCode and a property value of: checklist.
const initialChecklists = {
  // checkListCode: { /* checklist object */ }
  // checkListCode: { /* checklist object */ }
  // ...etc
};

const checklistsConfigReducer = createReducer(initialChecklists, {
  // Insert/Replace configuration for all checklists.
  [putChecklistsConfig]: (state, action) => {
    const checklists = action.payload;

    return checklists.reduce((newState, checklist) => {
      newState[checklist.checkListCode] = checklist; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...initialChecklists });
  },

  // Insert/Replace configuration for a single checklist in the list.
  [putChecklistConfig]: (state, action) => {
    const checklist = action.payload;

    return {
      ...state,
      [checklist.checkListCode]: checklist,
    };
  },

  // Insert/Replace configuration for a single category in a checklist.
  [putChecklistCategoryConfig]: (state, action) => {
    const checklistObj = action.payload;
    const { checklistId } = checklistObj;
    const { categoryId } = checklistObj;
    const { category } = checklistObj;
    const categories = [...state[checklistId].checkListCategories];
    categories[categories.findIndex(cat => cat.categoryCode === categoryId)] = category;

    return {
      ...state,
      [checklistId]: {
        ...state[checklistId],
        checkListCategories: categories,
      },
    };
  },
});

export default checklistsConfigReducer;
